import script from "./ProductCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductCard.vue?vue&type=script&setup=true&lang=js"

import "./ProductCard.vue?vue&type=style&index=0&id=c67f2270&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c67f2270"]])

export default __exports__